import { render, staticRenderFns } from "./ModalPreCheckinFaceRecognition.vue?vue&type=template&id=de862fc4"
import script from "./ModalPreCheckinFaceRecognition.vue?vue&type=script&lang=js"
export * from "./ModalPreCheckinFaceRecognition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports